(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var VIDEO_SELECTOR = 'video[data-deferred-autoplay]';
    var UNLOCK_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var supervisors = [];
    var playFns = new WeakMap();
    var hasArmedOnce = false;

    /* Playback supervisor.

       An autoplaying gallery video must never be left on a still frame, and
       several things outside this file stop it: media.js pauses every
       <deferred-media> on the page whenever any of them starts, the same
       happens on `dialog:close`, mobile Safari pauses on app backgrounding,
       and the native context menu offers a Pause item. Rather than patch each
       of those, the video watches its own `pause` event and resumes. */
    function supervise(video) {
      var existing = playFns.get(video);
      if (existing) return existing;

      var retryTimer = null;
      var attemptsLeft = 5;
      var backoff = 300;
      var unlockBound = false;
      var replays = [];

      function clearRetry() {
        if (retryTimer) {
          clearTimeout(retryTimer);
          retryTimer = null;
        }
      }

      /* iOS Low Power Mode refuses programmatic playback outright until the
         visitor interacts with the page, so back off *and* wait for the first
         gesture — whichever lands first wins. */
      function onUnlock() {
        unbindUnlock();
        attemptsLeft = 5;
        backoff = 300;
        play();
      }

      function bindUnlock() {
        if (unlockBound) return;
        unlockBound = true;
        UNLOCK_EVENTS.forEach(function (type) {
          document.addEventListener(type, onUnlock, { once: true, passive: true, capture: true });
        });
      }

      function unbindUnlock() {
        if (!unlockBound) return;
        unlockBound = false;
        UNLOCK_EVENTS.forEach(function (type) {
          document.removeEventListener(type, onUnlock, { capture: true });
        });
      }

      function play() {
        clearRetry();
        if (reducedMotion.matches) return;
        if (!video.isConnected || video.ended || document.hidden) return;
        if (!video.paused) return;
        /* Safari re-checks the muted property, not just the attribute, when
           deciding whether an unprompted play() is allowed. */
        video.muted = true;
        video.preload = 'auto';
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(onPlayFailure);
        }
      }

      function onPlayFailure() {
        bindUnlock();
        if (attemptsLeft <= 0) return;
        attemptsLeft--;
        retryTimer = setTimeout(play, backoff);
        backoff = Math.min(backoff * 2, 5000);
      }

      function onPause() {
        var now = Date.now();
        replays.push(now);
        while (replays.length && now - replays[0] > 2000) replays.shift();
        if (replays.length > 10) {
          /* Something is fighting us; stop hammering and retry slowly so a
             pause/play loop can't peg the CPU. */
          clearRetry();
          replays.length = 0;
          retryTimer = setTimeout(play, 1000);
          return;
        }
        play();
      }

      video.addEventListener('pause', onPause);
      video.addEventListener('playing', function () {
        attemptsLeft = 5;
        backoff = 300;
        unbindUnlock();
        clearRetry();
      });
      /* Recover from a network hiccup, or from a <source> 404 cascading to the
         next SD/HD candidate. */
      ['loadeddata', 'canplay', 'stalled'].forEach(function (type) {
        video.addEventListener(type, function () {
          if (video.dataset.deferredStarted) play();
        });
      });

      playFns.set(video, play);
      supervisors.push({
        video: video,
        resume: function () {
          if (video.dataset.deferredStarted) play();
        },
      });
      return play;
    }

    /* Tab switch, app switch, and bfcache back-navigation all land here.
       media.js has its own resume handler but it is gated on
       `data-media-loaded`, which the deferred path never sets. */
    function resumeAll() {
      supervisors = supervisors.filter(function (entry) {
        return entry.video.isConnected;
      });
      supervisors.forEach(function (entry) {
        entry.resume();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') resumeAll();
    });
    window.addEventListener('pageshow', resumeAll);

    function startDeferredVideo(video) {
      if (video.dataset.deferredStarted) return;
      video.dataset.deferredStarted = 'true';
      supervise(video)();
    }

    function isNearViewport(el) {
      var rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;
      var margin = 200;
      return (
        rect.bottom > -margin
        && rect.top < window.innerHeight + margin
        && rect.right > -margin
        && rect.left < window.innerWidth + margin
      );
    }

    function armDeferredVideo(video) {
      if (video.dataset.deferredArmed) return;
      video.dataset.deferredArmed = 'true';

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              cleanup();
              startDeferredVideo(video);
            }
          });
        },
        { rootMargin: '200px' }
      );

      /* Geometry fallback: IntersectionObserver needs rendering frames and
         never delivers in some embedded/background contexts. Cheap manual
         checks on scroll (rAF-throttled) cover those, and the immediate
         check starts the above-the-fold hero right away. */
      var scrollRaf = null;
      function checkGeometry() {
        scrollRaf = null;
        if (video.dataset.deferredStarted) {
          cleanup();
          return;
        }
        if (isNearViewport(video)) {
          cleanup();
          startDeferredVideo(video);
        }
      }
      function onScrollOrResize() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(checkGeometry);
      }
      function cleanup() {
        observer.disconnect();
        window.removeEventListener('scroll', onScrollOrResize);
        window.removeEventListener('resize', onScrollOrResize);
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
      }

      observer.observe(video);
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      checkGeometry();
    }

    function armAll() {
      hasArmedOnce = true;
      /* The only way out of "always playing": visitors who have asked their OS
         for reduced motion get the poster frame instead. */
      if (reducedMotion.matches) return;
      document.querySelectorAll(VIDEO_SELECTOR).forEach(armDeferredVideo);
    }

    /* Nothing downloads until window load so the video can't compete with
       the LCP image, CSS, or fonts; then the observer starts only the
       videos that are actually near the viewport (carousel clones of the
       gallery video stay cold until scrolled to). */
    if (document.readyState === 'complete') {
      armAll();
    } else {
      window.addEventListener('load', armAll, { once: true });
      /* A hung third-party script can delay `load` indefinitely, which used to
         leave the hero permanently cold. Arming is idempotent, so an extra
         call a few seconds in costs nothing. */
      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          function () {
            setTimeout(armAll, 3000);
          },
          { once: true }
        );
      } else {
        setTimeout(armAll, 3000);
      }
    }

    /* Re-arm videos injected later (theme editor re-renders, and the
       media-gallery `replaceWith` on every variant change). Cheap: only
       reacts when such a video exists. */
    new MutationObserver(function () {
      if (!hasArmedOnce) return;
      var pending = document.querySelector(VIDEO_SELECTOR + ':not([data-deferred-armed])');
      if (pending) armAll();
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', function () {
        if (reducedMotion.matches) {
          /* play() bails on reduced motion, so the pause handler won't fight this. */
          supervisors.forEach(function (entry) {
            entry.video.pause();
          });
        } else {
          armAll();
          resumeAll();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
